<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>


<!-- Wrapper -->
<div class="flex flex-col flex-auto items-center w-full min-w-0">


    <!-- Header -->
    <div
        class="relative flex flex-col flex-0 justify-center w-full h-[72px] sm:h-[72px] md:h-[72px] overflow-hidden z-49 shadow dark:shadow-none ">
        <!-- Top bar -->
        <div class="relative dark flex flex-auto w-full px-[32px] md:px-[32px] bg-[#0A0F3D] items-center">
            <div class="flex items-center w-full  h-12 sm:h-15 md:h-15">
                <ng-container >
                    <!-- Logo -->
                    <!-- <div class="flex items-center mx-2 lg:mr-8" [routerLink]="'/main/home'">
                        <div class="hidden lg:flex">
                            <img class="dark:hidden w-8" src="assets/images/logo_fase1.png">
                            <img class="hidden dark:flex w-8" src="assets/images/logo_fase1.png">
                        </div>
                        <img class="flex lg:hidden w-8" src="assets/images/logo_fase1.png">
                    </div> -->
                    <div class="flex items-center gap-8">
                        <div class="hidden lg:flex">
                            <img class="dark:hidden w-8" src="assets/images/logo_fase1.png">
                            <img class="hidden dark:flex w-8" src="assets/images/logo_fase1.png">
                        </div>
                        <img class="flex lg:hidden w-8" src="assets/images/logo_fase1.png">

                        <button mat-icon-button class="text-white" routerLink="/main">
                            <mat-icon>home</mat-icon>
                        </button>

                        <div class="hidden md:block items-center px-3 gap-1 flex ">
                            <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
                                <a *ngIf="!last" [routerLink]="breadcrumb.url"
                                    class="text-white text-lg font-medium cursor-pointer hover:underline">
                                    {{ breadcrumb.label }}
                                </a>
                                <span *ngIf="last" class="text-white text-lg font-medium">{{
                                    breadcrumb.label
                                    }}</span>

                                <span *ngIf="!last" class="text-lg font-medium text-white">/</span>
                            </ng-container>
                        </div>

                    </div>
                    <!-- Horizontal navigation has been removed as per user request to clean up the header -->
                </ng-container>

                <!-- Components -->
                <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">

                    <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>

                    <div class="flex items-center gap-3" [matMenuTriggerFor]="options" [matTooltip]="'Configuraciones'">
                        <mat-icon class="w-10 h-10 rounded-full" svgIcon="heroicons_outline:user-circle"></mat-icon>
                        

                        <div *ngIf="user">

                            <p class="text-white font-semibold">
                               {{ user.user_name? user.user_name : user.email }}
                            </p>

                            <p class="text-gray-300 text-sm">
                                {{group}}
                            </p>

                        </div>

                    </div>
                    <!-- Options menu -->
                    <mat-menu [xPosition]="'before'" #options="matMenu">
                        <ng-container *ngFor="let item of menu; let last = last">
                            
                            <!-- Insert Admin Menu just before the last item (Cerrar sesión) -->
                            <ng-container *ngIf="last && (user?.is_hyperadmin || adminNavigation[0]?.hidden() === false)">
                                <button mat-menu-item class="group" [matMenuTriggerFor]="adminSubMenu">
                                    <span class="flex items-center">
                                        <mat-icon svgIcon="heroicons_outline:building-office-2" class="text-primary"></mat-icon>
                                        <span class="ml-3 group-hover:text-primary">Administración</span>
                                    </span>
                                </button>
                            </ng-container>

                            <button *ngIf="item.visible" mat-menu-item class="group" (click)="setActiveLang(item.id)">
                                <span class="flex items-center">
                                    <mat-icon [svgIcon]="item.icon" class="text-primary"></mat-icon>

                                    <span class="ml-3 group-hover:text-primary">{{
                                        item.label
                                        }}</span>
                                </span>
                            </button>
                        </ng-container>
                    </mat-menu>

                    <!-- Admin Submenus -->
                    <mat-menu #adminSubMenu="matMenu">
                        <ng-container *ngFor="let groupItem of adminNavigation[0]?.children">
                            
                            <ng-container *ngIf="!groupItem.hidden()">
                                <!-- Basic item -->
                                <button *ngIf="groupItem.type === 'basic'" mat-menu-item [routerLink]="groupItem.link">
                                    <mat-icon *ngIf="groupItem.icon" [svgIcon]="groupItem.icon" class="text-primary"></mat-icon>
                                    {{ groupItem.title }}
                                </button>
                                
                                <!-- Collapsable item -->
                                <button *ngIf="groupItem.type === 'collapsable'" mat-menu-item [matMenuTriggerFor]="subMenuLevel3">
                                    <mat-icon *ngIf="groupItem.icon" [svgIcon]="groupItem.icon" class="text-primary"></mat-icon>
                                    {{ groupItem.title }}
                                </button>
                                
                                <!-- Nested Menu Level 3 -->
                                <mat-menu #subMenuLevel3="matMenu">
                                    <ng-container *ngFor="let childItem of groupItem.children">
                                        <button *ngIf="!childItem.hidden()" mat-menu-item [routerLink]="childItem.link">
                                            <mat-icon *ngIf="childItem.icon" [svgIcon]="childItem.icon" class="text-primary"></mat-icon>
                                            {{ childItem.title }}
                                        </button>
                                    </ng-container>
                                </mat-menu>
                            </ng-container>

                        </ng-container>
                    </mat-menu>

                </div>
                <!-- <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2 ">
                    <div *ngIf="user">
                        <p class="text-white-700">
                            Hola, <strong>{{ user.user_name? user.user_name : user.email }} </strong>
                        </p>
                    </div>

                    <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>

                    <button *ngIf="user" mat-icon-button [matMenuTriggerFor]="options" [matTooltip]="user.email">
                        <mat-icon svgIcon="heroicons_outline:user-circle"></mat-icon>
                    </button>

                    
                </div> -->
            </div>
        </div>
        <!-- Bottom bar -->
        <!-- <ng-container>
            <div class="flex flex-auto px-4 md:px-8 bg-card dark:bg-gray-700">
                <div class="relative flex items-center w-full max-w-360 h-9">
                    <div class="flex items-center gap text-primary border-2 mr-1 shadow-xl p-[2px] rounded-md cursor-pointer">
                        <mat-icon class="text-inherit cursor-pointer mt-[2px]" [svgIcon]="ICON.BACK_OUTLINE"
                            (click)="back()" title="Volver"></mat-icon>
                        <a class="cursor-pointer hover:underline mr-2 text-[12px]" (click)="back()">Atrás</a>
                    </div>
                    <div class="items-center px-3 gap-1 text-gray-700 flex text-[12px]">
                        <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
                            <a *ngIf="!last" [routerLink]="breadcrumb.url" class="cursor-pointer hover:underline">
                                {{ breadcrumb.label }}
                            </a>
                            <span *ngIf="last" class="font-bold">{{
                                breadcrumb.label
                                }}</span>

                            <span *ngIf="!last" class="text-gray-400">/</span>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-container> -->
    </div>



    <!-- Content -->
    <div class="flex flex-col flex-auto w-full">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div
        class="flex-0 items-center justify-end text-end w-full h-8 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden bottom-0 hidden xl:flex lg:flex md:flex">
        <span class="font-medium text-secondary w-full">Autocore &copy; {{ currentYear }} todos los derechos
            reservados</span>
    </div>

</div>